import { PriorityTypesTranslations } from "./types";

export const enPriorityTranslations: PriorityTypesTranslations = {
    LOW: "Low",
    MEDIUM: "Medium",
    HIGH: "High",
};
